import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import i18n from '@/localization/i18n';
import App from '@/App.vue';
import vuetify from '@/plugins/vuetify';
import store from '@/store';
import router from '@/router';
import { createMapInstance } from '@/main/mapInstance';
import VueSocialSharing from 'vue-social-sharing';

Vue.prototype.$map = createMapInstance();
Vue.use(VueSocialSharing);

(async () => {
  new Vue({
    i18n,
    store,
    router,
    //@ts-ignore
    vuetify,
    render: h => h(App)
  }).$mount('#app');
})();
